var render = function render(_c,_vm){return _c('v-lazy-image',{attrs:{"src":_vm.props.src,"src-placeholder":_vm.props.srcPlaceholder,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }